import { RegulationBdComponent } from './regulation/regulation-bd/regulation-bd.component';
import { SafeHtml } from '@angular/platform-browser';
import { Demoform2Component } from '../conponents/form/demoform2/demoform2.component';
import { NonConformanceComponent } from '../conponents/form/non-conformances/non-conformances.component';
import { ActionsComponent } from '../conponents/form/actions/actions.component';
import { DepManagementComponent } from './admin/dep-management/dep-management.component';
import { OrganizationTreeNodeComponent } from './admin/user-management/organization-tree-node/organization-tree-node.component';

// 匯入組織管理元件
import { OrganizationManagementComponent } from './regulation/organization-management/organization-management.component';
import { LanguageSwitcherComponent } from './shared/language-switcher/language-switcher.component';
import { FormBuilderComponent } from './form-builder/form-builder.component';
// 匯入動態API下拉選單元件
import { FormDynamicApiSelectComponent } from './items/form-dynamic-api-select.component';
// 匯入 MFA 相關元件
import { MfaSetupComponent } from './security/mfa-setup/mfa-setup.component';
import { MfaVerifyComponent } from './security/mfa-verify/mfa-verify.component';
import { MfaManagementComponent } from './security/mfa-management/mfa-management.component';
// 匯入簽核流程選擇元件
import { ApprovalFlowSelectorComponent } from './items/approval-flow-selector/approval-flow-selector.component';
// 匯入簽核流程表單元件
import { FormApprovalFlowComponent } from './items/form-approval-flow.component';
// 匯入簽核流程預覽元件
import { ApprovalFlowPreviewComponent } from './items/approval-flow-preview/approval-flow-preview.component';
// 匯入測試元件
import { ApprovalFlowTestComponent } from './test/approval-flow-test.component';
// 匯入施工申請表單元件
import { WorkApplicationFormComponent } from './ContractorManagement/work-application-form/work-application-form.component';
// 匯入 AI 客服元件
import { AiCustomerServiceComponent } from '../layouts/ai-customer-service/ai-customer-service.component';
// 匯入範本檔案上傳元件
import { TemplateFileUploadComponent } from '../shared/components/template-file-upload/template-file-upload.component';
// 匯入檔案上傳管理元件
import { FileUploadManagerComponent } from './items/file-upload-manager/file-upload-manager.component';
// 匯入表單資料卡片元件
import { FormDataCardComponent } from './form-data-card/form-data-card.component';
// 匯入階段編輯器元件
import { StageEditorComponent } from './stage-editor/stage-editor.component';
// 匯入填空元件
import { FillInFieldComponent } from './items/fill-in-field/fill-in-field.component';
// 匯入富文本顯示元件
import { FormRichTextDisplayComponent } from './items/form-rich-text-display.component';
// 匯入大頭照上傳元件
import { FormAvatarUploadComponent } from './items/form-avatar-upload/form-avatar-upload.component';
// 匯入簽核流程顯示元件
import { ApprovalFlowDisplayComponent } from './shared/approval-flow-display/approval-flow-display.component';
// 匯入法規管理元件
import { LawManagementComponent } from './admin/law-management/law-management.component';

import { SimulateExamComponent } from '../conponents/exam/simulate-exam/simulate-exam.component';

import { ShowlistComponent } from '../conponents/list/showlist/showlist.component';

import { ForkliftChecklistBydayComponent } from '../conponents/checklist/forklift-checklist-byday/forklift-checklist-byday.component';

import { FiledownloaderComponent } from '../conponents/tools/filedownloader/filedownloader.component';
import { PdfHelperComponent } from '../conponents/tools/pdf-helper/pdf-helper.component';
import { RqcodeComponent } from '../conponents/tools/rqcode/rqcode.component';

import { SafetyandHealthAgreementOrganizationMeetingComponent } from './ContractorManagement/safetyand-health-agreement-organization-meeting/safetyand-health-agreement-organization-meeting.component';
import { ContractorConstructionApplicationFormComponent } from './ContractorManagement/contractor-construction-application-form/contractor-construction-application-form.component';
import { FireWorkPermissionComponent } from './ContractorManagement/fire-work-permission/fire-work-permission.component';
import { CorrectiveActionFormComponent } from './ContractorManagement/corrective-action-form/corrective-action-form.component';
import { ContractorAnnualPerformanceComponent } from './ContractorManagement/contractor-annual-performance/contractor-annual-performance.component';
import { HazardNotificationandInspectionRecordComponent } from './ContractorManagement/hazard-notificationand-inspection-record/hazard-notificationand-inspection-record.component';

import { LineChartComponent } from '../conponents/chart/line-chart/line-chart.component';
import { CalendarPieComponent } from '../conponents/chart/calendar-pie/calendar-pie.component';

import { PdfViewerComponent } from '../conponents/tools/pdf-viewer/pdf-viewer.component';

import { YhAllclassComponent } from './yh/yh-allclass/yh-allclass.component';
import { YhAllclassTrendComponent } from './yh/yh-allclass-trend/yh-allclass-trend.component';

import { DynamicFormComponent } from './dynamic-form/dynamic-form/dynamic-form.component';
import { DynamicReportComponent } from './dynamic-report/dynamic-report/dynamic-report.component';

import { FormListTableComponent } from './form-list/form-list-table/form-list-table.component';
import { FormApprovalListComponent } from './form-list/form-approval-list/form-approval-list.component';
import { AzureBlobExplorerComponent } from './azure-blob-explorer/azure-blob-explorer.component';
import { RagTestComponent } from './rag-test/rag-test.component';

import { FilebankComponent } from '../pages/filebank/filebank.component';
import { SdsParserDialogComponent } from '../conponents/chemical/sds-parser-dialog/sds-parser-dialog.component';
import { SdsRegulationCheckComponent } from '../conponents/chemical/sds-regulation-check/sds-regulation-check.component';

import { LoglistComponent } from '../conponents/log/loglist/loglist.component';
import { UserManagementComponent } from '../conponents/admin/user-management/user-management.component';
import { AssistantManagementComponent } from '../conponents/admin/assistant-management/assistant-management.component';
import { CustomerDataManagementComponent } from '../conponents/admin/customer-data-management/customer-data-management.component';

import { RegulationListComponent } from './regulation/regulation-list/regulation-list.component';
import { ComplianceListComponent } from './regulation/compliance-list/compliance-list.component';
import { RegulationAdvanceSettingComponent } from './regulation/regulation-advance-setting/regulation-advance-setting.component';

import { LawUpdateNewsComponent } from './regulation/law-update-news/law-update-news.component';
import { BasicInfomationComponent } from './regulation/basic-infomation/basic-infomation.component';
import { EventRecordsComponent } from './regulation/event-records/event-records.component';
import { ReportsComponent } from './regulation/reports/reports.component';
import { TrackingItemComponent } from './regulation/tracking-item/tracking-item.component';
import { QuestionMagComponent } from './tpic/question-mag/question-mag.component';
import { ActionListComponent } from '../conponents/management_assistant/action-list/action-list.component';
import { ChemicalRegulationComponent } from './chemical/chemical-regulation/chemical-regulation.component';

// 添加導入承攬商管理的區塊
import { ContractorInfoComponent } from './ContractorManagement/contractor-info/contractor-info.component';
import { ContractorReportComponent } from './ContractorManagement/contractor-report/contractor-report.component';
import { EntryExitManagementComponent } from './ContractorManagement/entry-exit-management/entry-exit-management.component';
import { WorkApplicationComponent } from './ContractorManagement/work-application/work-application.component';
import { WorkOverviewComponent } from './ContractorManagement/work-overview/work-overview.component';

// 添加新建的化學相關元件
import { SdsListComponent } from './chemical/sds-list/sds-list.component';
import { UseListComponent } from './chemical/use-list/use-list.component';
import { RiskAssessmentComponent } from './chemical/risk-assessment/risk-assessment.component';
import { ChemicalReportComponent } from './chemical/chemical-report/chemical-report.component';
import { ControlListComponent } from './chemical/control-list/control-list.component';

// 導入新建的自檢相關元件
import { SelfCheckListComponent } from './self_check/self-check-list/self-check-list.component';
import { ImprovementItemsComponent } from './self_check/improvement-items/improvement-items.component';
import { SelfCheckReportComponent } from './self_check/self-check-report/self-check-report.component';

// 導入簽核相關元件
import { ApprovalStatusComponent } from './items/approval/approval-status/approval-status.component';
import { ApprovalFlowManagementComponent } from './items/approval/approval-flow-management/approval-flow-management.component';


// 導入會議簽名收集相關元件
import { MeetingSignatureCollectionComponent } from './items/signature/meeting-signature-collection/meeting-signature-collection.component';
import { SdsParserComponent } from './chemical/sds-parser/sds-parser.component';
import { Plant3DMapComponent } from './3DMap/plant3-dmap/plant3-dmap.component';
import { LawUpdateAndCompareComponent } from './regulation/law-update-and-compare/law-update-and-compare.component';
import { LawSampleManagementComponent } from './regulation/law-sample-management/law-sample-management.component';
import { FileDisplayComponent } from './items/file-display/file-display.component';
import { FormAudioRecorderComponent } from './items/form-audio-recorder.component';
import { RequiredDocumentUploadComponent } from './items/required-document-upload/required-document-upload.component';
import { DynamicListComponent } from '../conponents/dynamic-list/dynamic-list.component';
import { FormDynamicApiTableComponent } from './items/form-dynamic-api-table.component';
import { FormAutoNumberingComponent } from './items/form-auto-numbering/form-auto-numbering.component';
import { AiAssistantEditorComponent } from './ai-assistant-editor/ai-assistant-editor.component';

export const COMPONENT_MAP: { [key: string]: any } = {
  demoform2component: Demoform2Component,
  filedownloader: FiledownloaderComponent,
  nonConformanceComponent: NonConformanceComponent,
  showlistComponent: ShowlistComponent,
  lineChartComponent: LineChartComponent,
  forkliftChecklistBydayComponent: ForkliftChecklistBydayComponent,
  pdfHelperComponent: PdfHelperComponent,
  actionsComponent: ActionsComponent,
  SafetyandHealthAgreementOrganizationMeetingComponent:
    SafetyandHealthAgreementOrganizationMeetingComponent,
  ContractorConstructionApplicationFormComponent:
    ContractorConstructionApplicationFormComponent,
  FireWorkPermissionComponent: FireWorkPermissionComponent,
  CorrectiveActionFormComponent: CorrectiveActionFormComponent,
  ContractorAnnualPerformanceComponent: ContractorAnnualPerformanceComponent,
  HazardNotificationandInspectionRecordComponent:
    HazardNotificationandInspectionRecordComponent,
  CalendarPieComponent: CalendarPieComponent,
  PdfViewerComponent: PdfViewerComponent,
  RqcodeComponent: RqcodeComponent,

  simulateExamComponent: SimulateExamComponent,

  YhAllclassComponent: YhAllclassComponent,
  YhAllclassTrendComponent: YhAllclassTrendComponent,
  DynamicFormComponent: DynamicFormComponent,
  DynamicReportComponent: DynamicReportComponent,
  FormListTableComponent: FormListTableComponent,
  FormApprovalListComponent: FormApprovalListComponent,
  AzureBlobExplorerComponent: AzureBlobExplorerComponent,
  RagTestComponent: RagTestComponent,
  FilebankComponent: FilebankComponent,
  SdsRegulationCheckComponent: SdsRegulationCheckComponent,
  SdsParserDialogComponent: SdsParserDialogComponent,
  loglistComponent: LoglistComponent,
  userManagementComponent: UserManagementComponent,
  organizationTreeNodeComponent: OrganizationTreeNodeComponent,
  assistantManagementComponent: AssistantManagementComponent,
  customerDataManagementComponent: CustomerDataManagementComponent,

  regulationListComponent: RegulationListComponent,
  complianceListComponent: ComplianceListComponent,
  regulationAdvanceSettingComponent: RegulationAdvanceSettingComponent,
  lawUpdateNewsComponent: LawUpdateNewsComponent,
  basicInfomationComponent: BasicInfomationComponent,
  eventRecordsComponent: EventRecordsComponent,
  regulationBdComponent: RegulationBdComponent,
  reportsComponent: ReportsComponent,
  trackingItemComponent: TrackingItemComponent,
  questionMagComponent: QuestionMagComponent,
  actionListComponent: ActionListComponent,
  chemicalRegulationComponent: ChemicalRegulationComponent,

  contractorInfoComponent: ContractorInfoComponent,
  workApplicationComponent: WorkApplicationComponent,
  workOverviewComponent: WorkOverviewComponent,
  contractorReportComponent: ContractorReportComponent,
  entryExitManagementComponent: EntryExitManagementComponent,

  // 添加新建的化學相關元件到組件映射中
  sdsListComponent: SdsListComponent,
  useListComponent: UseListComponent,
  riskAssessmentComponent: RiskAssessmentComponent,
  chemicalReportComponent: ChemicalReportComponent,
  controlListComponent: ControlListComponent, // 添加新的控制清單元件

  // 添加新建的自檢相關元件
  selfCheckListComponent: SelfCheckListComponent,
  improvementItemsComponent: ImprovementItemsComponent,
  selfCheckReportComponent: SelfCheckReportComponent,

  // 添加簽核相關元件
approvalStatusComponent: ApprovalStatusComponent,
approvalFlowManagementComponent: ApprovalFlowManagementComponent,

// 添加會議簽名收集元件
meetingSignatureCollectionComponent: MeetingSignatureCollectionComponent,
  // Adding new department management component
  depManagementComponent: DepManagementComponent,
  SdsParserComponent: SdsParserComponent,
  Plant3DMapComponent: Plant3DMapComponent,
  lawUpdateAndCompareComponent: LawUpdateAndCompareComponent,
  lawSampleManagementComponent: LawSampleManagementComponent,
  fileDisplayComponent: FileDisplayComponent,
  formAudioRecorderComponent: FormAudioRecorderComponent,
  requiredDocumentUploadComponent: RequiredDocumentUploadComponent,
   DynamicListComponent: DynamicListComponent,
   formDynamicApiTableComponent: FormDynamicApiTableComponent,
   formAutoNumberingComponent: FormAutoNumberingComponent,

  // 新增元件映射
  organizationManagementComponent: OrganizationManagementComponent,
  languageSwitcherComponent: LanguageSwitcherComponent,
  formBuilderComponent: FormBuilderComponent,
  formDynamicApiSelectComponent: FormDynamicApiSelectComponent,
  mfaSetupComponent: MfaSetupComponent,
  mfaVerifyComponent: MfaVerifyComponent,
  mfaManagementComponent: MfaManagementComponent,
  approvalFlowSelectorComponent: ApprovalFlowSelectorComponent,
  formApprovalFlowComponent: FormApprovalFlowComponent,
  approvalFlowPreviewComponent: ApprovalFlowPreviewComponent,
  approvalFlowTestComponent: ApprovalFlowTestComponent,
  workApplicationFormComponent: WorkApplicationFormComponent,
  aiCustomerServiceComponent: AiCustomerServiceComponent,
  templateFileUploadComponent: TemplateFileUploadComponent,
  fileUploadManagerComponent: FileUploadManagerComponent,
  formDataCardComponent: FormDataCardComponent,
  stageEditorComponent: StageEditorComponent,
  fillInFieldComponent: FillInFieldComponent,
  formRichTextDisplayComponent: FormRichTextDisplayComponent,
  formAvatarUploadComponent: FormAvatarUploadComponent,
  approvalFlowDisplayComponent: ApprovalFlowDisplayComponent,
  lawManagementComponent: LawManagementComponent,
  aiAssistantEditorComponent: AiAssistantEditorComponent,
};
